/**
 * AJP Native Product Options
 *
 * UI/field behaviour only.
 * Paid add-on cart submission is deliberately handled by product-form.js so
 * there is a single owner of the Add to Cart request.
 */
(() => {
  const PAID = '[data-ajp-paid-option]';
  const OPTION = '[data-ajp-product-option]';
  const CONDITIONAL_INPUT = '[data-ajp-conditional-input]';

  const syncConditionalField = (checkbox) => {
    const selector = checkbox.dataset.ajpControls;
    if (!selector) return;

    const wrapper = document.querySelector(selector);
    if (!wrapper) return;

    const input = wrapper.querySelector(CONDITIONAL_INPUT);
    const open = checkbox.checked && !checkbox.disabled;

    wrapper.hidden = !open;
    wrapper.classList.toggle('tw-hidden', !open);

    if (!input) return;

    input.disabled = !open;
    input.required = open && input.dataset.ajpRequired === 'true';

    if (!open) input.value = '';
  };

  const syncDynamicCheckout = (checkbox) => {
    const section = checkbox?.closest('section') || document;

    const hasPaidSelection = [...section.querySelectorAll(PAID)].some(
      (input) => input.checked && !input.disabled
    );

    section.querySelectorAll('.shopify-payment-button').forEach((button) => {
      button.hidden = hasPaidSelection;
    });
  };

  const initPaidCheckbox = (checkbox) => {
    if (checkbox.dataset.ajpInitialised === 'true') return;

    checkbox.dataset.ajpInitialised = 'true';
    syncConditionalField(checkbox);

    checkbox.addEventListener('change', () => {
      syncConditionalField(checkbox);
      syncDynamicCheckout(checkbox);
    });
  };

  const validateDate = (input) => {
    if (!input.matches('[data-ajp-max-today]') || !input.value || !input.max) return true;

    const valid = input.value <= input.max;

    input.parentElement
      ?.querySelector('[data-ajp-date-error]')
      ?.classList.toggle('tw-hidden', valid);

    if (!valid) input.value = '';

    return valid;
  };

  const initialise = (root = document) => {
    if (root.matches?.(PAID)) initPaidCheckbox(root);

    root.querySelectorAll?.(PAID).forEach(initPaidCheckbox);
    root.querySelectorAll?.('[data-ajp-max-today]').forEach((input) => validateDate(input));

    const firstPaid = root.matches?.(PAID) ? root : root.querySelector?.(PAID);
    if (firstPaid) syncDynamicCheckout(firstPaid);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-ajp-max-today]')) validateDate(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:block:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:block:select', (event) => initialise(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches(OPTION) || node.querySelector(OPTION)) {
          initialise(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
